import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput, { findItem } from 'Components/forms/select-input/SelectInput.jsx';
import TextField from 'Components/forms/text-field/TextField';
import Label from 'Components/forms/label/Label';
import MessageDropdown from 'Components/MessageDropdown/MessageDropdown.jsx';
import './MerchantMessage.scss';
import { getPredefinedMessage } from 'Apis/caseDataAPI';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { removeInvalidCharacters } from "Utils/validationUtils";
import { COLORS } from "Constants/BIDashboardConstants"

let messageTypes = [];

const languageMapper = [
  {
    languageIndCode: 'EN',
    languageText: 'English',
  },
  {
    languageIndCode: 'FRN',
    languageText: 'French',
  },
  {
    languageIndCode: 'FR',
    languageText: 'French',
  },
  {
    languageIndCode: 'CH',
    languageText: 'Chinese',
  },
];

class MerchantMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPredef: {
        englishLanguage: '',
        preferredLanguage: '',
      },
      predefMessages: [],
      languageIndCode: '',
      languageText: '',
      letterTemplates: [],
      messageLength: {
        messageEnglishLength: 0,
        messageOtherLength: 0,
      },
      selections: {
        letterTemplate: {
          value: 'choose-one',
          text: 'Choose One',
        },
        messageType: {
          value: '',
          text: '',
        },
      },
      messageTypes: [
      ],
      textAreaValue:"",
    };
    //messageTypes = [];


    this.attachBindings();
  }

  attachBindings() {
    this.onMessageTypeChange = this.onMessageTypeChange.bind(this);
    this.onLetterTemplateChange = this.onLetterTemplateChange.bind(this);
    this.onEnglishMessageChange = this.onEnglishMessageChange.bind(this);
    this.onOtherMessageChange = this.onOtherMessageChange.bind(this);
    this.selectDropdownItem = this.selectDropdownItem.bind(this);
    this.fetchPredefinedMessages = this.fetchPredefinedMessages.bind(this);
  }

  componentWillMount() {

    const stateSelections = { ...this.state.selections };
    if (this.props.messageType.value !== '') {
      stateSelections.messageType = this.props.messageType;
    } else {
      stateSelections.messageType = {
        value: 'predefined',
        text: 'Predefined',
      };
    }
    if (this.props.letterTemplate.value !== '') {
      stateSelections.letterTemplate = this.props.letterTemplate;
    }
    this.setState({
      selections: stateSelections,
    });

    if (this.props.predefMessage.englishLanguage !== '') {
      this.setState({
        selectedPredef: this.props.predefMessage,
      });
    }

    if (this.props.englishMessage !== '') {
      const englishMessage = this.props.englishMessage;
      const otherMessage = this.props.otherMessage;
      const stateMessageLength = { ...this.state.messageLength };
      stateMessageLength.messageEnglishLength = englishMessage.length;
      stateMessageLength.messageOtherLength = otherMessage.length;
      this.setState({
        messageLength: stateMessageLength,
      });
    }
  }

  componentDidMount() {
    if (this.state.selections.letterTemplate.value === '') {
      this.props.onDisableNextStep(true);
    }
    messageTypes = [];

    messageTypes.push({
      value: 'predefined',
      text: 'Predefined',
    });

    this.props.userPermissions.case.addCustomMerchantVerbiage &&
      messageTypes.push({
        value: 'custom',
        text: 'Custom',
      });

    this.setState({
      messageTypes,
      predefMessages: this.props.predefMessages,
      languageIndCode: this.props.languageIndCode,
      languageText: this.props.languageText,
      letterTemplates: this.props.letterTemplates,
      selections: this.props.selections,
    })
    this.props.fetchLangId(this.state.selections.letterTemplate.text, this.state.selections.letterTemplate.value);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.selectedActionIssuerId !== newProps.selectedActionIssuerId || (this.props.predefMessages !== newProps.predefMessages || this.props.selections !== newProps.selections) || (newProps.letterTemplates && newProps.letterTemplates.length > 0)) {
      this.setState({
        predefMessages: newProps.predefMessages,
        languageIndCode: newProps.languageIndCode,
        languageText: newProps.languageText,
        letterTemplates: newProps.letterTemplates,
        selections: newProps.selections,
      })
    }
    const stateSelections = { ...this.state.selections };
    if (newProps.messageType.value !== '') {
      stateSelections.messageType = newProps.messageType;
    } else {
      stateSelections.messageType = {
        value: 'predefined',
        text: 'Predefined',
      };
    }
    if (newProps.letterTemplate.value !== '') {
      stateSelections.letterTemplate = newProps.letterTemplate;
    } else {
      stateSelections.letterTemplate.value = 'choose-one';
      stateSelections.letterTemplate.text = 'Choose One';
    }
    this.setState({
      selections: stateSelections,
    });

    if (newProps.predefMessage.englishLanguage !== '') {
      this.setState({
        selectedPredef: newProps.predefMessage,
      });
    } else {
      const newSelectedPredef = {
        englishLanguage: '',
        preferredLanguage: '',
      };
      this.setState({
        selectedPredef: newSelectedPredef,
      });
    }
    const englishMessage = newProps.englishMessage;
    const otherMessage = newProps.otherMessage;
    const stateMessageLength = { ...this.state.messageLength };
    stateMessageLength.messageEnglishLength = englishMessage.length;
    stateMessageLength.messageOtherLength = otherMessage.length;
    this.setState({
      messageLength: stateMessageLength,
    });
  }

  componentWillUpdate(nextState) {
    if (nextState.languageIndCode !== undefined && nextState.languageIndCode !== this.state.languageIndCode) {
      this.fetchPredefinedMessages(nextState.languageIndCode);
    }
  }

  fetchPredefinedMessages(languageIndCode) {
    getPredefinedMessage(languageIndCode, this.props.caseStageId)
      .then((apiResponse) => {
        this.setState({
          predefMessages: apiResponse.data,
        });
      })
      .catch((error) => {
        console.log('Unable to fetch letter template', error);
      });
  }

  onMessageTypeChange(value) {
    if (this.props.messageType.value !== value) {
      const newSelection = findItem(messageTypes, value);
      this.props.fetchMessageType(newSelection);
      const stateSelections = { ...this.state.selections };
      stateSelections.messageType = newSelection;
      if (newSelection) {
        this.setState({
          selections: stateSelections,
        });
      }
      if (newSelection.value === 'custom') {
        if (this.state.languageText === 'English') {
          this.props.fetchEnglishMessageData(this.state.selectedPredef.englishLanguage, this.state.languageIndCode);
        } else {
          this.props.fetchEnglishMessageData(this.state.selectedPredef.englishLanguage, this.state.languageIndCode);
          this.props.fetchOtherMessageData(this.state.selectedPredef.preferredLanguage, this.state.languageIndCode, this.state.languageText);
        }
      } else if (newSelection.value === 'predefined') {
        const newItem = {
          englishLanguage: this.state.selectedPredef.englishLanguage,
          preferredLanguage: this.state.selectedPredef.preferredLanguage,
        };
        this.props.fetchPredefMessageData(newItem, this.state.languageIndCode, this.state.languageText);
      }
    }
  }

  onLetterTemplateChange(value) {
    const letterTemplates = this.state.letterTemplates;
    const newSelection = findItem(letterTemplates, value);
    this.props.fetchLangId(newSelection.text, value);
    const stateSelections = { ...this.state.selections };
    stateSelections.letterTemplate = newSelection;
    if (newSelection) {
      this.setState({ selections: stateSelections });
    }
  }

  onEnglishMessageChange(value) {
    this.props.fetchEnglishMessageData(value, this.state.languageIndCode);
    const messageLength = value?.length;
    const stateMessageLength = { ...this.state.messageLength };
    stateMessageLength.messageEnglishLength = messageLength;
    this.setState({
      [this.state.messageLength.messageEnglishLength]: value?.length,
      textAreaValue: value,
      messageLength: stateMessageLength,
    });
  }

  onOtherMessageChange(value) {
    this.props.fetchOtherMessageData(value, this.state.languageIndCode, this.state.languageText);
    const messageLength = value?.length;
    const stateMessageLength = { ...this.state.messageLength };
    stateMessageLength.messageOtherLength = messageLength;
    this.setState({
      messageLength: stateMessageLength,
    });
  }

  selectDropdownItem(item) {
    this.props.fetchPredefMessageData(item, this.state.languageIndCode, this.state.languageText);
    this.setState({
      selectedPredef: item,
    });
  }

  render() {
    const languageText = `Message in Merchant Preferred Language ${this.state.languageText !== undefined ? `(${this.state.languageText})` : ''}`;
    return (
      this.props.isMerchantMessageError || this.state.letterTemplates !== undefined && this.state.letterTemplates.length > 0 ?
        <div className="merchant-message-wrapper">
          <div className="dropdown-selection">
            <TextField
              fieldClass={`field--fixed-width ${this.props.skipNotifyMerchant} ? curssor-not-allowed : ""`}
              htmlFor="Letter Template"
              width="350px"
              labelContent={(
                <span data-radium>
                  <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }} htmlFor="Letter Template Label" labelClass="field-label checkbox-group-parent-label">Letter Template</Label>
                </span>
              )}
            >
              <SelectInput
                selectClass={{ zIndex: 1, width: 'unset' }}
                dataList={this.state.letterTemplates !== undefined ? this.state.letterTemplates : []}
                wrapperClass="select-menu__form reports"
                extraClass="option-box"
                optionTextWrapCssClass="Merchant-message-wrapper option-text-wrap"
                handleSelection={this.onLetterTemplateChange}
                selectedItem={this.state.selections.letterTemplate}
                isDisabled={this.props.skipNotifyMerchant}
                isReadOnlyGreyDisable={this.props.skipNotifyMerchant}
                disableClick={this.props.skipNotifyMerchant}
              />
            </TextField>

            <TextField
              fieldClass={`field--fixed-width ${this.props.skipNotifyMerchant} ? curssor-not-allowed : ""`}
              htmlFor="Message Type"
              width="350px"
              labelContent={(
                <span data-radium>
                  <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Type Label" labelClass="field-label checkbox-group-parent-label">Message Type</Label>
                </span>
              )}
            >
              <SelectInput
                selectClass={{ zIndex: 1 }}
                dataList={messageTypes}
                wrapperClass="select-menu__form reports"
                extraClass="option-box"
                handleSelection={this.onMessageTypeChange}
                selectedItem={this.state.selections.messageType}
                isDisabled={this.props.skipNotifyMerchant}
                isReadOnlyGreyDisable={this.props.skipNotifyMerchant}
                disableClick={this.props.skipNotifyMerchant}
              />
            </TextField>

          </div>
          <div className="message-container">
            {this.state.languageText === 'English' && this.state.selections && this.state.selections.messageType && this.state.selections.messageType.value === 'custom' && (
              <div className="message-custom-english">
                <TextField
                  fieldClass="field--fixed-width"
                  display="inline-block"
                  htmlFor="Message"
                  width="730px"
                  labelContent={(
                    <span data-radium>
                      <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Label" labelClass="field-label checkbox-group-parent-label">
                        Message
                      <div style={{color: `${COLORS.oneGp.black}`}} className="message-text-char">
                          {this.state.textAreaValue.length}
                          /9000
                      </div>
                      </Label>
                    </span>
                  )}
                >
                  <textarea
                    ref="notes"
                    id="textArea"
                    maxLength="9000"
                    // onChange={(event) => { this.setState({ [this.state.messageLength.messageEnglishLength]: event.target.value.length, textAreaValue: event.target.value }); }}
                    // onBlur={this.onEnglishMessageChange}
                    onChange={(event)=> this.onEnglishMessageChange(removeInvalidCharacters(event.target.value))}
                    className="message-text-area"
                    value={this.props.englishMessage}
                    >
                  </textarea>
                </TextField>
              </div>
            )}
            {this.state.languageText !== 'English' && this.state.selections.messageType.value === 'custom' &&
              (
                <div className="message-custom-other">
                  <div className="message-box-half">
                    <TextField
                      fieldClass="field--fixed-width"
                      display="inline-block"
                      htmlFor="Message in English Language"
                      width="350px"
                      labelContent={(
                        <span data-radium>
                          <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }} htmlFor="Message in English Language label" labelClass="field-label checkbox-group-parent-label">
                            Message in English Language
                        <div className="message-text-char">
                              {this.state.messageLength.messageEnglishLength}
                              /9000
                        </div>
                          </Label>
                        </span>
                      )}
                    >
                      <textarea ref="notes" id="textArea" maxLength="9000" value={this.props.englishMessage} onChange={(event)=> this.onEnglishMessageChange(removeInvalidCharacters(event.target.value))} className="message-text-area-half"></textarea>
                    </TextField>
                  </div>
                  <div className="message-box-half">
                    <TextField
                      fieldClass="field--fixed-width"
                      display="inline-block"
                      htmlFor="Message in Merchant Preffered Language"
                      width="350px"
                      labelContent={(
                        <span data-radium>
                          <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }} htmlFor="Message in Merchant Preffered Language label" labelClass="field-label checkbox-group-parent-label">{languageText}
                            <div className="message-text-char"> {this.state.messageLength.messageOtherLength}/9000 </div>
                          </Label>
                        </span>
                      )}
                    >
                      <textarea ref="notes" id="textArea" maxLength="9000" value={this.props.otherMessage} onChange={(event)=> {this.onOtherMessageChange(removeInvalidCharacters(event.target.value, "Preffered"))}} className="message-text-area-half" ></textarea>
                    </TextField>
                  </div>
                </div>
              )}
            {this.state.languageText === 'English' && this.state.selections.messageType.value !== 'custom' && (
              <div className="message-predef-english">
                <div className="select-input-predef">
                  <TextField
                    fieldClass="field--fixed-width"
                    htmlFor="Message Dropdown"
                    labelContent={(
                      <span data-radium>
                        <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Dropdown label" labelClass="field-label checkbox-group-parent-label">Message</Label>
                      </span>
                    )}
                  >
                    <MessageDropdown
                      dropdownList={this.state.predefMessages}
                      selectDropdownItem={this.selectDropdownItem}
                      selectedItemText={this.state.selectedPredef.englishLanguage === '' ? 'Select Message' : this.state.selectedPredef.englishLanguage}
                    />
                  </TextField>
                </div>

                {this.state.selectedPredef.englishLanguage !== '' && (
                  <div className="message-text-area-wrapper">
                    <TextField
                      fieldClass="field--fixed-width"
                      display="inline-block"
                      htmlFor="Message Dropdown Container"
                      width="730px"
                      labelContent={(
                        <span data-radium>
                          <Label
                            extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }}
                            htmlFor="Message Dropdown Container label"
                            labelClass="field-label checkbox-group-parent-label"
                          >
                            Message
                        </Label>
                        </span>
                      )}
                    >
                      <div style={{ fontWeight: 500 }} className="message-text-area-disabled">
                        {this.state.selectedPredef.englishLanguage}
                      </div>
                    </TextField>
                  </div>
                )}
              </div>
            )}
            {this.state.languageText !== 'English' && this.state.selections.messageType.value !== 'custom' && <div className="message-predef-other">
              <div className="select-input-predef">
                <TextField
                  fieldClass="field--fixed-width"
                  htmlFor="Message Dropdown"
                  labelContent={<span data-radium>
                    <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Dropdown label" labelClass="field-label checkbox-group-parent-label">Message</Label>
                  </span>}
                >
                  <MessageDropdown
                    dropdownList={this.state.predefMessages}
                    selectDropdownItem={this.selectDropdownItem}
                    selectedItemText={this.state.selectedPredef.englishLanguage === '' ? 'Select Message' : this.state.selectedPredef.englishLanguage}
                  />
                </TextField>
              </div>
              <div className="message-box-half-disabled-wraper">
                {this.state.selectedPredef.englishLanguage !== '' && <div className="message-box-half"><TextField
                  fieldClass="field--fixed-width"
                  htmlFor="Message Dropdown Container English"
                  display="inline-block"
                  width="350px"
                  labelContent={<span data-radium>
                    <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Dropdown Container English label" labelClass="field-label checkbox-group-parent-label">Message in English Language
                  </Label>
                  </span>}
                >
                  <div style={{ fontWeight: 500 }} className="message-text-area-half-disabled">{this.state.selectedPredef.englishLanguage}</div>
                </TextField></div>}

                {this.state.selectedPredef.englishLanguage !== '' && <div className="message-box-half"><TextField
                  fieldClass="field--fixed-width"
                  htmlFor="Message Dropdown Container Other"
                  display="inline-block"
                  width="350px"
                  labelContent={<span data-radium>
                    <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="Message Dropdown Container Other label" labelClass="field-label checkbox-group-parent-label">{languageText}
                    </Label>
                  </span>}
                >
                  <div style={{ fontWeight: 500 }} className="message-text-area-half-disabled">{this.state.selectedPredef.preferredLanguage}</div>
                </TextField></div>}
              </div>
            </div>}
          </div>
        </div>
        :<BVLoader20 />
    );
  }
}
MerchantMessage.propTypes = {
  extraClass: PropTypes.string,
};

MerchantMessage.defaultProps = {
  extraClass: '',
};

export default MerchantMessage;
